<app-breadcrumbs title="Pending Quality Checks" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <!-- Header -->
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">
          <i class="ri-checkbox-circle-line align-middle me-1"></i>
          Pending Quality Check Items
        </h5>
      </div>

      <!-- Inline Quality Check Form (Show/Hide) -->
      <div class="card-body border-bottom" *ngIf="showForm" id="qualityCheckForm">
        <div class="bg-light p-4 rounded">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">
              <i class="ri-checkbox-circle-line align-middle me-1"></i>
              Perform Quality Check
            </h5>
            <button type="button" class="btn btn-sm btn-light" (click)="cancelForm()">
              <i class="ri-close-line align-bottom"></i>
            </button>
          </div>

          <div *ngIf="selectedItem" class="alert alert-info mb-3">
            <strong>Item:</strong> {{ selectedItem.item_name }} ({{ selectedItem.item_code }})<br>
            <strong>GRN:</strong> {{ selectedItem.grn_number }} | <strong>PO:</strong> {{ selectedItem.po_number }}<br>
            <strong>Pending Quantity:</strong> {{ selectedItem.pending_quantity | number: '1.2-2' }} {{ selectedItem.unit_symbol }}
          </div>

          <form>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">QC Date <span class="text-danger">*</span></label>
                <input type="date" 
                       class="form-control" 
                       [(ngModel)]="qualityCheckForm.qc_date"
                       name="qc_date"
                       required>
              </div>

              <div class="col-md-6">
                <label class="form-label">Status <span class="text-danger">*</span></label>
                <select class="form-control" 
                        [(ngModel)]="qualityCheckForm.status"
                        name="status"
                        required>
                  <option value="Passed">Passed</option>
                  <option value="Failed">Failed</option>
                </select>
              </div>

              <div class="col-12">
                <label class="form-label">Test Parameters</label>
                <textarea class="form-control" 
                          rows="3"
                          [(ngModel)]="qualityCheckForm.test_parameters"
                          name="test_parameters"
                          placeholder="e.g., Visual inspection, dimension check"></textarea>
              </div>

              <div class="col-12">
                <label class="form-label">Observations</label>
                <textarea class="form-control" 
                          rows="3"
                          [(ngModel)]="qualityCheckForm.observations"
                          name="observations"
                          placeholder="e.g., All items in good condition"></textarea>
              </div>

              <div class="col-12">
                <label class="form-label">Remarks</label>
                <textarea class="form-control" 
                          rows="2"
                          [(ngModel)]="qualityCheckForm.remarks"
                          name="remarks"
                          placeholder="Additional remarks"></textarea>
              </div>

              <div class="col-12">
                <div class="d-flex gap-2 justify-content-end">
                  <button type="button" 
                          class="btn btn-light" 
                          (click)="cancelForm()"
                          [disabled]="isSubmitting">
                    Cancel
                  </button>
                  <button type="button" 
                          class="btn btn-primary" 
                          (click)="submitQualityCheck()"
                          [disabled]="isSubmitting">
                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
                    <i *ngIf="!isSubmitting" class="ri-check-line align-bottom me-1"></i>
                    {{ isSubmitting ? 'Submitting...' : 'Submit Quality Check' }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Filters -->
      <div class="card-body border-bottom">
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Material Acceptance</label>
            <select class="form-control" [(ngModel)]="materialAcceptanceId">
              <option value="">All Material Acceptances</option>
              <option *ngFor="let ma of materialAcceptances" [value]="ma.id">
                {{ ma.grnNumber }} - {{ ma.purchaseOrder?.poNumber }}
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label">Item</label>
            <select class="form-control" [(ngModel)]="itemId">
              <option value="">All Items</option>
              <option *ngFor="let item of items" [value]="item.id">
                {{ item.name }} ({{ item.code }})
              </option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">From Date</label>
            <input type="date" class="form-control" [(ngModel)]="fromDate" />
          </div>

          <div class="col-md-2">
            <label class="form-label">To Date</label>
            <input type="date" class="form-control" [(ngModel)]="toDate" />
          </div>

          <div class="col-md-2 d-flex align-items-end gap-2">
            <button class="btn btn-primary" (click)="applyFilters()">
              <i class="ri-search-line align-bottom me-1"></i> Search
            </button>
            <button class="btn btn-light" (click)="resetFilters()">
              <i class="ri-refresh-line align-bottom"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card-body pt-0">
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!isLoading" class="table-responsive table-card mb-0">
          <table class="table align-middle table-nowrap">
            <thead class="table-light">
              <tr>
                <th>GRN #</th>
                <th>PO #</th>
                <th>Item</th>
                <th>Received Quantity</th>
                <th>Accepted Quantity</th>
                <th>Pending Quantity</th>
                <th>Received Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="qualityCheckItems.length === 0">
                <td colspan="10" class="text-center py-4">
                  <div class="text-muted">
                    <i class="ri-inbox-line fs-1"></i>
                    <p class="mt-2">No pending quality check items found</p>
                  </div>
                </td>
              </tr>

              <tr *ngFor="let item of qualityCheckItems">
                <td><strong>{{ item.grn_number || '-' }}</strong></td>
                <td>{{ item.po_number || '-' }}</td>
                <td>
                  <div>
                    <strong>{{ item.item_name || '-' }}</strong>
                    <br>
                    <small class="text-muted">{{ item.item_code || '-' }}</small>
                  </div>
                </td>
                <td>{{ item.received_quantity | number: '1.2-2' }} {{ item.unit_symbol }}</td>
                <td>{{ item.accepted_quantity | number: '1.2-2' }} {{ item.unit_symbol }}</td>
                <td>{{ item.pending_quantity | number: '1.2-2' }} {{ item.unit_symbol }}</td>
                <td>{{ item.received_date | date: 'mediumDate' }}</td>
                <td>
                  <span class="badge text-uppercase" [ngClass]="getStatusClass(item.status || 'Pending QC')">
                    {{ item.status || 'Pending ' }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-primary" 
                          (click)="openQualityCheckForm(item)"
                          ngbTooltip="Perform Quality Check">
                    <i class="ri-check-line align-bottom me-1"></i> QC
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row justify-content-md-between align-items-md-center mt-3" *ngIf="totalRecords > 0 && !isLoading">
          <div class="col col-sm-6">
            <div class="dataTables_info mb-2">
              Showing {{ ((page - 1) * pageSize) + 1 }} to {{ (page * pageSize) > totalRecords ? totalRecords : (page * pageSize) }} of {{ totalRecords }} entries
            </div>
          </div>
          <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
              <ngb-pagination [collectionSize]="totalRecords" 
                              [(page)]="page" 
                              [pageSize]="pageSize" 
                              (pageChange)="changePage()">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
